import { authApi } from "services/api";

export type EventStatus = "active" | "end" | "not_start";

export class EventStatusError extends Error {
	constructor(public status: EventStatus) {
		super(`Event is not active: ${status}`);
		this.name = "EventStatusError";
	}
}

const CACHE_TTL_MS = 5000;

let cachedEventId: string | undefined;
let cachedAt = 0;
let fetchPromise: Promise<string> | undefined;

const fetchEventId = async (): Promise<string> => {
	const eventResponse = await authApi.getEventId();
	const eventStatus = eventResponse.event?.status as EventStatus;
	if (eventStatus !== "active") {
		throw new EventStatusError(eventStatus || "not_start");
	}
	return eventResponse.event?.id || process.env.REACT_APP_EVENT_ID || "";
};

export const getEventId = async (): Promise<string> => {
	if (process.env.NODE_ENV === "development") {
		return process.env.REACT_APP_EVENT_ID || "";
	}

	const now = Date.now();
	if (cachedEventId !== undefined && now - cachedAt < CACHE_TTL_MS) {
		return cachedEventId;
	}

	if (!fetchPromise) {
		fetchPromise = fetchEventId()
			.then((eventId) => {
				cachedEventId = eventId;
				cachedAt = Date.now();
				return eventId;
			})
			.finally(() => {
				fetchPromise = undefined;
			});
	}

	return fetchPromise;
};
